import Vue from 'vue'
import moment from 'moment'

const state = {
  openedBoard: false,
  lists: [],
  boardId: null,
  boardTitle: '',
  department: null,
  preference: {},
  readOnly: false
}

// reusable code
const get = key => (state) => {
  return state[key]
}

// getters
const getters = {
  openedBoard: get('openedBoard'),

  boardId: get('boardId'),

  boardTitle: get('boardTitle'),

  department: get('department'),

  preference: get('preference'),

  lists: get('lists'),

  backlogList: state => {
    return state.lists[0]
  },

  isReadOnly: get('readOnly')
}

// actions
const actions = {
  // Informa que um quadro foi aberto. Sempre deve ser chamado ao abrir um cartão
  openBoard ({ commit, dispatch, getters }, id) {
    if (getters.boardId === null) {
      dispatch('listFilter/clear', getters.innerLists, { root: true })
    }
    commit('BOARD_STATE', id)
  },

  addDetails ({ commit }, { title, department, preference }) {
    commit('BOARD_DETAILS', { title, department, preference })
  },

  // Adiciona as listas de um quadro, por padrão sempre são 4
  addLists ({ commit }, lists) {
    commit('SET_LISTS', lists)
  },

  // Adiciona um cartão na lista à fazer
  addCard ({ commit }, card) {
    commit('ADD_CARD', card)
  },

  // remove um card da lista que este de encontra
  removeCard ({ commit }, column) {
    commit('REMOVE_CARD', column)
  },

  // Informa que um quadro foi fechado
  closeBoard ({ commit }) {
    commit('BOARD_STATE', false)
  },

  // Atualiza as tags de todos os cartões
  updateTags ({ commit }, mode) {
    commit('UPDATE_TAGS', mode)
  },

  moveCardToDone ({ commit }, cardId) {
    commit('MOVE_TO_DONE', cardId)
  },

  moveCardToDoing ({ commit }, cardId) {
    commit('MOVE_TO_DOING', cardId)
  },

  updatePreference ({ commit }, preference) {
    commit('UPDATE_PREFERENCE', preference)
  },

  // Altera manualmente o vencimento das checklists no carditem
  setCardOverdueStatus ({ commit }, card) {
    commit('UPDATE_CARD_OVERDUE_STATUS', card)
  },

  removeFromDone ({ commit }, cardId) {
    commit('REMOVE_CARD_FROM_DONE', cardId)
  },

  // Ordena cartões de determinada lista
  applyListOrderBy ({ commit }, orderedList) {
    commit('ORDER_LIST', orderedList)
  },

  updateTitle ({ commit }, title) {
    commit('ADD_TITLE', title)
  },

  openCardFromPath ({ dispatch, getters }, cardId) {
    getters.lists.forEach(list => {
      let card = list.cards.find(f => f.id === cardId)
      if (card) {
        dispatch('card/showCard', card, { root: true })
      }
    })
  },

  setReadOnly ({ commit }, readOnly) {
    commit('SET_READ_ONLY', readOnly)
  },

  updateDepartmentId ({ commit }, departmentId) {
    commit('UPDATE_DEPARTMENT_ID', departmentId)
  },

  updateChangedCardPosition ({ commit }, card) {
    commit('UPDATE_CHANGED_CARD_POSITION', card)
  },

  addCardsToList ({ commit }, data) {
    commit('ADD_CARDS_TO_LIST', data)
  }
}

// mutations
const mutations = {
  BOARD_STATE (state, boardId) {
    state.openedBoard = boardId > 0 && boardId != null
    if (state.openedBoard) {
      state.boardId = boardId
    } else {
      state.boardId = null
      state.boardTitle = ''
      state.department = null
      state.preference = {}
    }
  },

  BOARD_DETAILS (state, { title, department, preference }) {
    state.boardTitle = title
    state.department = department

    if (preference) {
      Vue.set(state.preference, 'triggerShadow', preference.triggerShadow)
      Vue.set(state.preference, 'detachShadow', preference.detachShadow)
      Vue.set(state.preference, 'withLoggedUser', preference.withLoggedUser)
      Vue.set(state.preference, 'withoutUser', preference.withoutUser && preference.withLoggedUser)
      Vue.set(state.preference, 'onlyShadow', false)
      Vue.set(state.preference, 'selectedUser', false)
    }
  },

  SET_LISTS (state, lists) {
    state.lists = null
    state.lists = []
    state.lists = lists
  },

  ADD_CARD (state, card) {
    state.lists[0].cards.push(card)
    state.lists[0].totalCards++
  },

  REMOVE_CARD (state, column) {
    let list = column.listId
    let card = column.cardId

    let currList = state.lists.find(find => find.id === list)
    if (currList !== null) {
      Vue.set(currList, 'cards', currList.cards.filter(filter => filter.id !== card))
      Vue.set(currList, 'totalCards', currList.totalCards - 1)
    }
  },

  UPDATE_TAGS (state, mode) {
    state.lists.forEach((list, i) => {
      list.cards.forEach((card, j) => {
        let index = card.tags.findIndex(fil => fil.id === mode.tag.id)
        if (index >= 0) {
          if (mode.action === 'deleteAll') {
            card.tags.splice(index, 1)
          } else {
            card.tags.splice(index, 1, mode.tag)
          }
          Vue.set(state.lists[i].cards[j], 'tags', card.tags)
        }
      })
    })
  },
  MOVE_TO_DONE (state, cardId) {
    state.lists.forEach(list => {
      if (list.title !== 'Concluído') {
        let index = list.cards.findIndex(fIndex => fIndex.id === cardId)

        if (index >= 0) {
          state.lists[3].cards.push(list.cards[index])
          state.lists[3].totalCards++
          list.cards.splice(index, 1)
          list.totalCards--
        }
      }
    })
  },
  MOVE_TO_DOING (state, cardId) {
    state.lists.forEach(list => {
      let index = list.cards.findIndex(fIndex => fIndex.id === cardId)

      if (index >= 0) {
        state.lists[1].cards.splice(0, 0, list.cards[index])
        state.lists[1].totalCards++
        list.cards.splice(index, 1)
        list.totalCards--
      }
    })
  },
  UPDATE_PREFERENCE (state, preference) {
    state.preference = preference
  },
  UPDATE_CARD_OVERDUE_STATUS (state, card) {
    moment.locale('pt-br')
    let removeOverdueStatus = false
    let checkLists = card.checkLists.filter(fil => fil.checked !== 'notapplicable' && fil.checked !== 'canceled')
    let alteredCheckLists = card.checkLists.filter(fil => fil.checked === 'notapplicable' || fil.checked === 'canceled')

    if (checkLists.length > 0) {
      checkLists.forEach(checkList => {
        let goalDate = moment(checkList.dateGoalDue, 'DD/MM/YYYY')
        let dueDate = moment(checkList.dateDue, 'DD/MM/YYYY')
        let beforeDate = checkList.doneDateTime === '' ? moment(moment(), 'DD/MM/YYYY') : moment(checkList.doneDateTime, 'DD/MM/YYYY')

        if ((!dueDate.isBefore(beforeDate) && !goalDate.isBefore(beforeDate)) && (alteredCheckLists.length > 0)) {
          removeOverdueStatus = true
        }
      })
    }

    if (removeOverdueStatus || (checkLists.length === 0 && alteredCheckLists.length > 0)) {
      let lists = state.lists
      for (let i = 0; i < lists.length; i++) {
        let cardItem = lists[i].cards.find(find => find.id === card.id)
        if (cardItem) {
          cardItem.hasCheckListOverdue = false
        }
      }
    }
  },
  // CLOSE_BOARD_FROM_LIST (state) {
  //   let lists = state.lists

  //   for (let i = 0; i < lists.length; i++) {
  //     let listCards = lists[i].cards.filter(fil => !fil.shadow)

  //     if (listCards.length > 0 && i < 3) {
  //       state.openedBoard = true
  //       break
  //     } else if (listCards.length > 0 && i === 3) {
  //       state.openedBoard = false
  //     }
  //   }
  // },
  REMOVE_CARD_FROM_DONE (state, cardId) {
    let lists = state.lists
    let card = lists[3].cards.find(find => find.id === cardId)

    if (card) {
      lists[1].cards.push(card)
      lists[1].totalCards++
      Vue.set(lists[3], 'cards', lists[3].cards.filter(filter => filter.id !== cardId))
      Vue.set(lists[3], 'totalCards', lists[3].totalCards - 1)
    }
  },
  ORDER_LIST (state, orderedList) {
    let list = state.lists.find(find => find.id === orderedList.id)
    list.cards = orderedList.cards
  },
  ADD_TITLE (state, title) {
    state.boardTitle = title
  },
  SET_READ_ONLY (state, readOnly) {
    state.readOnly = readOnly
  },
  UPDATE_DEPARTMENT_ID (state, departmentId) {
    state.department = departmentId
  },
  UPDATE_CHANGED_CARD_POSITION (state, card) {
    state.lists.forEach(list => {
      let index = list.cards.findIndex(fIndex => fIndex.id === card.id)
      if (index >= 0) {
        list.cards[index].checkedItems = card.checkedItems
        list.cards[index].users = card.users
        if (card.listType > 0) {
          state.lists[card.listType].cards.push(list.cards[index])
          state.lists[card.listType].totalCards++
          list.cards.splice(index, 1)
          list.totalCards--
        }
      }
    })
  },
  ADD_CARDS_TO_LIST (state, data) {
    state.lists[data.type].cards.push(...data.cards)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
